/**
 * @file Gera os niveis e dimensiona o jogo.<br>
 * Pré-configura 3 niveis de jogo.
 * @author William Luis Alves Ferreira (git:illiamw)
 * @version 2.0.0
 */
/**
 *
 * @module ControlLevel
 */

/** Gera os niveis e controles do jogo.<br>
 * Pré-configura 3 niveis de jogo. */
export default function ControlLevel() {

    this.setDimensoes =  function(largura, altura){
        this.largura = largura;
        this.altura = altura;
        console.log(this.altura)
    }

    this.setQuantidadePalavras =  function(palavras){
        this.palavras = palavras;
    }

    this.getQuantidadePalavras = function(){
        return this.palavras;
    }

    this.getLargura = function(){
        return this.largura;        
    }

    this.getAltura = function(){
        return this.altura;        
    }

    this.getNivel = function(){
        return this.nivel;        
    }

    this.facil = function(){
        console.log('entrou')
        this.nivel = 'Facíl';
        this.conjuto = 1;
        this.setDimensoes(10,16);
        this.setQuantidadePalavras(6);
    }

    this.medio = function(){
        this.nivel = 'Médio';
        this.conjuto = 2;
        this.setDimensoes(10,16);
        this.setQuantidadePalavras(8);
    }

    this.dificil = function(){
        this.nivel = 'Difícil';
        this.conjuto = 3;
        this.setDimensoes(10,16);
        this.setQuantidadePalavras(10);
    }
   

}
